import React from "react";
import { Link } from "react-router-dom";

/**
 * A way back, in the same place on every screen that has one.
 *
 * Always an explicit destination rather than browser history: landing on
 * a page from a notification or a shared link leaves history pointing
 * somewhere unhelpful, and "back" that sometimes leaves the app is worse
 * than no back at all.
 */
export default function Back({ to, children }) {
  return (
    <Link to={to} className="back">
      <span className="back-arrow" aria-hidden="true" />
      <span>{children}</span>
    </Link>
  );
}
